import React from 'react';
import styles from './Header.module.css';
import masaLogo from '../Assets/MasaLogo.png';


function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <img src={masaLogo} alt="Company Logo" className={styles.logo} />
        <div className={styles.headerInfo}>
          <h1 className={styles.title}>Factory Login</h1>
          <div className={styles.selection}>
            <span className={styles.label}>Access Control</span>
            <span className={styles.label}>Secure Login</span>
          </div>
          <p className={styles.description}>Please enter your credentials to access the system</p>
        </div>
      </div>
    </header>
  );
}

export default Header;